import { DoodUserModel } from '@store/authentication/authentication.model';

/** Auth selector values as read from the NgRx authentication store. */
export interface Cb2PreviewAuthSelectorValues {
  user: DoodUserModel | null;
  isUserLoaded: boolean;
  isUserLoading: boolean;
  isLoggedIn: boolean;
  isAnonymous: boolean;
  userId: string | undefined;
  metafields: unknown;
}

/** Disconnected visitor snapshot exposed to CB2 preview consumers. */
export const CB2_PREVIEW_DISCONNECTED_AUTH: Cb2PreviewAuthSelectorValues = {
  user: null,
  isUserLoaded: true,
  isUserLoading: false,
  isLoggedIn: false,
  isAnonymous: true,
  userId: undefined,
  metafields: undefined,
};

/**
 * When CB2 preview is active, masks the real auth store as disconnected so
 * modals and visibility rules render for an anonymous visitor. Outside preview
 * the store values are returned unchanged.
 *
 * Callers that sync Firebase ↔ store (e.g. AuthFirebaseService.isAuthSynced$)
 * must skip live hydration in preview — a Firebase session + masked null user
 * would otherwise look like a desync and trigger GET /users/me.
 */
export function resolveCb2PreviewAuthSelectorValues(
  previewActive: boolean,
  storeValues: Cb2PreviewAuthSelectorValues,
): Cb2PreviewAuthSelectorValues {
  const snapshot = previewActive ? CB2_PREVIEW_DISCONNECTED_AUTH : storeValues;
  return {
    ...snapshot,
    userId: snapshot.userId ?? undefined,
  };
}
